@if (label() || hint()) {
  <div class="field-label-row">
    @if (label()) {
      <span class="field-label" [attr.for]="inputId()">
        {{ label() }}

        @if (required()) {
          <span class="field-required">*</span>
        }
      </span>
    }

    @if (hint()) {
      <span class="field-hint">{{ hint() }}</span>
    }
  </div>
}

<div class="field-control">
  @if (iconLeft()) {
    <i
      class="field-icon field-icon-left {{ iconLeft() }}"
      aria-hidden="true"
    ></i>
  }

  @if (prefix()) {
    <span class="field-affix field-prefix">{{ prefix() }}</span>
  }

  @if (effectiveMask()) {
    <input
      #inputEl
      class="field-input"
      [id]="inputId()"
      [type]="effectiveInputType()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [ngModel]="value()"
      (ngModelChange)="onModelChange($event)"
      [ngModelOptions]="{ standalone: true }"
      [mask]="effectiveMask()"
      [prefix]="effectivePrefix()"
      [thousandSeparator]="effectiveThousandSeparator()"
      decimalMarker=","
      [dropSpecialCharacters]="effectiveDropSpecialCharacters()"
      [leadZero]="false"
      [attr.inputmode]="effectiveInputMode()"
      [style.paddingLeft]="inputPaddingLeft()"
      [style.paddingRight]="inputPaddingRight()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.enter)="onEnterKey($event)"
    />
  } @else {
    <input
      #inputEl
      class="field-input"
      [id]="inputId()"
      [type]="type()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [ngModel]="value()"
      (ngModelChange)="onModelChange($event)"
      [ngModelOptions]="{ standalone: true }"
      [style.paddingLeft]="inputPaddingLeft()"
      [style.paddingRight]="inputPaddingRight()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.enter)="onEnterKey($event)"
    />
  }

  @if (suffix()) {
    <span class="field-affix field-suffix">{{ suffix() }}</span>
  }

  @if (iconRight()) {
    <i
      class="field-icon field-icon-right {{ iconRight() }}"
      aria-hidden="true"
    ></i>
  }
</div>

@if (displayMessage()) {
  <span class="field-message" [class.field-message-error]="hasError()">
    @if (hasError()) {
      <i
        class="fa-sharp fa-light fa-circle-exclamation"
        style="position: relative; top: -1px;"
        aria-hidden="true"
      ></i>
    }

    {{ displayMessage() }}
  </span>
}
